module.exports = __webpack_public_path__ + "img/dates.5c9912c5.svg";